"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Button_1 = require("@Components/Buttons/Button");
const react_1 = __importDefault(require("react"));
require("./index.scss");
const DisputeOptionItem = (props) => {
    const { title, body, onClick, buttonText, disabled, dataTooltipId } = props;
    return (react_1.default.createElement("div", { className: 'dispute-option-item' },
        react_1.default.createElement("div", { className: 'top-section' },
            react_1.default.createElement("div", { className: 'top-section-header' },
                react_1.default.createElement("h6", null, title)),
            react_1.default.createElement("div", { className: 'top-section-body' },
                react_1.default.createElement("p", null, body))),
        react_1.default.createElement("div", { className: 'dispute-option-button-container', "data-tooltip-id": dataTooltipId },
            react_1.default.createElement(Button_1.Button, { type: 'primary', disabled: disabled, mainColor: true, onClick: onClick }, buttonText))));
};
exports.default = DisputeOptionItem;
